import React, { useState } from 'react'
import { Button, Typography, Paper, Stack, Grid, TextField, Snackbar, Alert } from '@mui/material';

import Header from "../components/Header";
import Footer from "../components/Footer";
import PasswordDialog from "../components/dialogs/PasswordDialog";

import SEO from "../components/SEO";

import { Box } from '@mui/system';

import useMediaQuery from '@mui/material/useMediaQuery';


export default function Register() {
    const matches = useMediaQuery((theme) => theme.breakpoints.up('sm'));

    const [open, setOpen] = useState(false);
    const style = {
        background: {
            //backgroundImage: `linear-gradient(transparent, white 50%), url(${background})`,
            paddingLeft: 2,
            paddingRight: 2,
            borderRadius: 0,
            paddingBottom: 0,
            paddingTop: 5,
            '@media only screen and (max-width: 900px)': {
                paddingTop: 2
            }
        },
        body: {
            '@media only screen and (min-width: 480px)': {
                marginLeft: '2%',
                marginRight: '2%',
            },
            '@media only screen and (min-width: 1700px)': {
                marginLeft: '10%',
                marginRight: '10%',
            },
        },
        typography: {
            fontWeight: "bold",
            opacity: 0.7,
            paddingBottom: 2,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 0,
                fontSize: 35,
                textAlign: "center"
            }
        },
        bodyText: {
            paddingBottom: 2,
            marginTop: 2,
            letterSpacing: 1,
            opacity: 0.7,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 0,
                marginTop: 2,
            }
        },
        contactButton: {
            marginTop: 4,
            marginBottom: 4,
            paddingLeft: 10,
            border: '3px black solid',
            color: (theme) => theme.palette.common.black,
            paddingTop: 1,
            textTransform: "none",
            paddingBottom: 1,
            paddingRight: 10,
            opacity: 0.6,
            fontSize: 15,
            borderRadius: 5,
            boxShadow: 0,
            "&:hover": {
                border: '3px #3E73DB solid',
                color: (theme) => theme.palette.primary.main,
                opacity: 1,
            },
        },
        centerDiv: {
            '@media only screen and (max-width: 900px)': {
                textAlign: "center"
            }
        },
        memojiCenter: {
            display: "flex",
            '@media screen and (min-width: 900px)': {
                display: "none"
            }
        },
        memojiLeft: {
            '@media screen and (max-width: 900px)': {
                display: "none"
            }
        },
        cardMedia: {
            borderRadius: 0,
            minWidth: 200,
            '@media screen and (min-width: 900px)': {
                height: "100%",
            }
        },
        linkText: {
            fontStyle: "italic",
            fontWeight: "bold",
            color: (theme) => theme.palette.primary.main
        },
        cardMediaLarge: {
            borderRadius: 0,
            '@media screen and (min-width: 900px)': {
                height: "100%",
            }
        },
        footerStyle: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            textAlign: "center"
        },
        textField: {
            minWidth: matches ? 400 : 300,
            '& label.Mui-focused': {
                color: (theme) => theme.palette.primary.main,
            },
            '& .MuiOutlinedInput-root': {
                fontStyle: "italic",
                borderRadius: 7,
                '&.Mui-focused fieldset': {
                    border: "3px black solid",
                },
            },
        },
    }
    const signup = (e) => {
        e.preventDefault();
        if (!payload.userFirstName || !payload.userLastName || !payload.userAddress || !payload.userEmail || !payload.userContact) {
            setAlert({
                message: "Please make sure to fill in the empty fields.",
                severity: "warning"
            })
            setSnack(true)
        } else {
            setOpen(true);
        }
    }
    const handleChange = (prop) => (e) => {
        setPayload({ ...payload, [prop]: e.target.value });
    }

    const [payload, setPayload] = useState({
        userFirstName: "",
        userLastName: "",
        userAddress: "",
        userEmail: "",
        userContact: "",
        userPass: ""
    })
    const [snack, setSnack] = useState(false);
    const [alert, setAlert] = useState({
        message: "This is an alert message.",
        severity: "success",
    })
    const handleSnack = () => {
        setSnack(false);
    }

    const memojiBox = (
        <Stack
            sx={{ marginTop: matches ? 10 : 2, }}
            direction="column"
            alignItems="center"
            spacing={2}
        >
            <TextField
                inputProps={{ style: { textAlign: 'center' } }}
                variant='outlined'
                placeholder='First Name'
                value={payload.userFirstName}
                onChange={handleChange("userFirstName")}
                sx={style.textField} />
            <TextField
                inputProps={{ style: { textAlign: 'center' } }}
                variant='outlined'
                placeholder='Last Name'
                value={payload.userLastName}
                onChange={handleChange("userLastName")}
                sx={style.textField} />
            <TextField
                inputProps={{ style: { textAlign: 'center' } }}
                variant='outlined'
                placeholder='Address'
                value={payload.userAddress}
                onChange={handleChange("userAddress")}
                sx={style.textField} />
            <TextField
                inputProps={{ style: { textAlign: 'center' } }}
                variant='outlined'
                placeholder='Email Address'
                value={payload.userEmail}
                onChange={handleChange("userEmail")}
                sx={style.textField} />
            <TextField
                inputProps={{ style: { textAlign: 'center' } }}
                variant='outlined'
                placeholder='Contact Number'
                value={payload.userContact}
                onChange={handleChange("userContact")}
                sx={style.textField} />

            <Button
                variant="outlined"
                sx={style.contactButton}
                onClick={signup}
            >
                Sign Up
            </Button>
        </Stack>
    )

    const vertical = "top";
    const horizontal = "center";

    return (
        <Box>
            <SEO title="Register - Baliwag Municipal Library" description="RANIELLA VILLARAMA WEB DEVELOPER PORTFOLIO ... About" />
            <Paper sx={style.background} elevation={0}>
                <Header />
                <Box sx={style.body}>
                    <Stack
                        sx={style.centerDiv}
                        direction={{ xs: 'column', md: 'row' }}
                        spacing={{ xs: 1, sm: 2, md: 5 }}>
                        <Stack direction="row" spacing={2} >
                            <Box sx={{ marginTop: matches ? 10 : 4 }}>
                                <Typography sx={style.typography} variant="h1" color="default">Welcome! We are glad to have you</Typography>
                                <Typography
                                    sx={style.bodyText}
                                    variant={matches ? "h6" : "subtitle1"}
                                    color="default"
                                    display="inline">
                                    Fill the following fields with its corresponding data to create your account.
                                </Typography>
                                <Box >
                                    <Grid container columns={12} sx={style.memojiCenter}>
                                        <Grid item xs={12}>
                                            {memojiBox}
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Box>
                            <Box sx={style.memojiLeft}>
                                {memojiBox}
                            </Box>
                        </Stack>
                    </Stack>
                </Box>
                <Box sx={{ height: 100 }} />
                <Snackbar open={snack} autoHideDuration={6000} onClose={handleSnack} anchorOrigin={{ vertical, horizontal }}>
                    <Alert onClose={handleSnack} severity={alert.severity} sx={{ width: '100%' }}>
                        {alert.message}
                    </Alert>
                </Snackbar>
            </Paper>
            <Box sx={style.footerStyle}>
                <Footer />
            </Box>
            <PasswordDialog open={open} setOpen={setOpen} payload={payload} />
        </Box>
    )
}
